import { render, staticRenderFns } from "./forms.pug?vue&type=template&id=48a5d671&lang=pug&"
import script from "./forms.js?vue&type=script&lang=js&"
export * from "./forms.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48a5d671')) {
      api.createRecord('48a5d671', component.options)
    } else {
      api.reload('48a5d671', component.options)
    }
    module.hot.accept("./forms.pug?vue&type=template&id=48a5d671&lang=pug&", function () {
      api.rerender('48a5d671', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/adminLayout/views/forms/index.vue"
export default component.exports